document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.carousel-container').forEach(function(container){
    var track      = container.querySelector('.carousel');
    var prevBtn    = container.querySelector('.prev');
    var nextBtn    = container.querySelector('.next');
    var slide      = container.querySelector('.carousel-slide');
    var style      = window.getComputedStyle(slide);
    var slideWidth = slide.offsetWidth + parseInt(style.marginRight);

    prevBtn.addEventListener('click', function(){
      track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function(){
      track.scrollBy({ left:  slideWidth, behavior: 'smooth' });
    });
  });
});
